/**
 * Method Refactorized On AUG 2021
 * User: edwin.rebolledo
 * */
import React, { useEffect, useState } from "react";
import Axios from "axios";
import swal from "sweetalert";
import { useParams, useHistory } from "react-router-dom";
import PatientsForProvider from "./PatientsForProvider";
import providerIcon from "../../images/doctor.svg";
import UseUserState from "../hooks/useUserState";
import DashboardAdmin from "../administrator/DashboardAdmin";
import LoadingSpin from "../utils/Loading";
import StarsComponent from "../utils/StarsComponent";
import ProfileImg from "../../images/profile-2.svg";
import {
  CheckCircleOutline as CheckCircleOutlineIcon,
  Cancel as CancelIcon,
  CloudDownload as CloudDownloadIcon,
} from "@material-ui/icons";

import {
  Button,
  Chip,
  Input,
  InputLabel,
  Select,
  Tabs,
  Tab,
  Box,
} from "@material-ui/core";
//import Button from "@material-ui/core/Button";
import {
  CircularProgress,
  Backdrop,
  MenuItem,
  FormControl,
  FormControlLabel,
  TextField,
  Switch,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import useBDocTranslator from "../hooks/useBDocTranslator";
import Planner from "../planner/Planner";
import { makeStyles } from "@material-ui/core/styles";
import AdminProviderPlanner from "./AdminProviderPlanner";

const useStyles = makeStyles((theme) => ({
  tabs: {
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    marginBottom: theme.spacing(2),
  },
  tabPanel: {
    backgroundColor: "#fff",
    borderRadius: "4px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

function ProviderEditFromAdmin() {
  const storeState = UseUserState();
  let { id } = useParams();
  const [data, setData] = useState("");
  let history = useHistory();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [firstName, setfirstName] = useState("");
  const [lastname, setLastname] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [gender, setGender] = useState("");
  const [identification, setIdentification] = useState("");
  const [identificationType, setIdentificationType] = useState("");
  const [country, setCountry] = useState("");
  const [summary, setSummary] = useState("");
  const [nationality, setNationality] = useState("");
  const [providerStatus, setProviderStatus] = useState("disabled"); //THIS FIELD IS RELATED TO THE PROVIDER IN GRAL TERMS.
  const [open, setOpen] = useState(false);
  const [statusUpdated, setStatusUpdated] = useState(false);
  const [imgLoading, setImgLoading] = useState(false);
  const [imgProfile, setImgProfile] = useState("");
  const [countries, setCountries] = useState([]);
  const [issuedBy, setIssuedBy] = useState("");
  const [specialty, setSpecialty] = useState([]);
  const [selectedSpecialty, setSelectedSpecialty] = useState([]);
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const [providerId, setProviderId] = useState("");
  const [medicalLicense, setMedicalLicense] = useState("");
  const [reviewStatusCode, setReviewStatusCode] = useState({
    new: false,
    code: "",
  });
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [primaryLanguage, setPrimaryLanguage] = useState("");
  const [secondaryLanguage, setSecondaryLanguage] = useState("");

  const [providerLocations, setProviderLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [locationPreSelected, setLocationPreSelected] = useState("");
  const [consultation_allowed, setConsultationAllowed] = useState(0);
  const [platformLocations, setPlatformLocations] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [dentalEhrEnabled, setDentalEhrEnabled] = useState(false);
  const [aiEnabled, setAiEnabled] = useState(false);
  const [assistantEnabled, setAssistantEnabled] = useState(false);
  const [assistantInputTokenLimit, setAssistantInputTokenLimit] =
    useState("");

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const classes = useStyles();

  // ----------------- COUNTRIES ----------------------

  const findCountries = () => {
    Axios.get(`${process.env.REACT_APP_API_URL_BASE}/countries/findAll`)
      .then((res) => {
        setCountries(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //Specialties stored on BD
  const findSpecialties = async () => {
    try {
      const result = await Axios.get(
        `${process.env.REACT_APP_API_URL_BASE}/specialty/findAll`
      );
      if (result) {
        setSpecialty(result.data);
      }
    } catch (error) {
      console.error("Something wrong", error);
    }
  };

  const getWindowDimension = (e) => {
    setWidth(
      window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth
    );
    setHeight(
      window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
    );
  };

  //Used by Backdrop to unlock the screen
  const handleClose = () => {
    setOpen(false);
  };

  //to handle the selected specialities selected on control
  const handleChangeSpecialty = (sp) => {
    if (sp) {
      console.log("sp", sp);
      setSelectedSpecialty(sp);
    }
  };

  async function loadDataToControls(data) {
    if (data) {
      const {
        id,
        firstName,
        lastname,
        identification,
        dateOfBirth,
        gender,
        country,
        nationality,
        phone1,
        identificationType,
        summary,
        medical_license,
        issued_by,
        medical_speciality,
        primary_language,
        secondary_language,
        provider_locations,
        dental_ehr_enabled,
        ai_enabled,
        assistant_enabled,
        assistant_input_token_limit,
        user: {
          user_images,
          email,
          status_user: { name },
        },
        status_provider: { code },
      } = data;
      setfirstName(firstName);
      setLastname(lastname);
      setIdentification(identification);
      setDateOfBirth(dateOfBirth && dateOfBirth.split("T")[0]);
      setGender(gender);
      setCountry(country);
      setNationality(nationality);
      setProviderId(id);
      setPhone(phone1);
      setIdentificationType(identificationType);
      setSummary(summary);
      setIssuedBy(issued_by);
      setMedicalLicense(medical_license);
      await findSpecialties();
      if (medical_speciality) setSelectedSpecialty([medical_speciality]);
      setImgProfile(
        user_images?.length > 0 ? user_images[0].path_resource : ProfileImg
      );
      setEmail(email);
      setReviewStatusCode({ new: false, code: code });
      setProviderStatus(name);
      setPrimaryLanguage(primary_language);
      setSecondaryLanguage(secondary_language);
      // setProviderLocations(provider_locations);
      setSelectedLocations(provider_locations);
      setDentalEhrEnabled(dental_ehr_enabled || false);
      setAiEnabled(ai_enabled || false);
      setAssistantEnabled(assistant_enabled || false);
      setAssistantInputTokenLimit(
        assistant_input_token_limit === null ||
          assistant_input_token_limit === undefined
          ? ""
          : assistant_input_token_limit
      );
    }
  }

  useEffect(() => {
    setLoading(true);
    setOpen(true);
    setImgLoading(true);
    getWindowDimension();
    findCountries();
    getLocations();

    async function fetchProviderData() {
      const result = await Axios.get(
        `${process.env.REACT_APP_API_URL_BASE}/provider/review/${id}`,
        {
          headers: {
            Authorization: "Bearer " + storeState[0].jwt, //the jwt is a variable which holds the token
          },
        }
      );
      setData(result.data);
      return result;
    }

    async function fetchPatientRelated(userId) {
      const result = await Axios.get(
        `${process.env.REACT_APP_API_URL_BASE}/patient/forProvider?providerId=${id}&createdBy=${userId}`,
        {
          headers: {
            Authorization: "Bearer " + storeState[0].jwt, //the jwt is a variable which holds the token
          },
        }
      );
      // filter the result for non null values
      const filteredResult = result.data.filter((patient) => patient !== null);
      return filteredResult;
    }

    async function processRequest() {
      const dataProvider = await fetchProviderData();
      await loadDataToControls(dataProvider.data);
      const patients = await fetchPatientRelated(dataProvider?.data?.user?.id);
      setPatients(patients);
      setImgLoading(false);
      setOpen(false);
    }

    processRequest();
    setLoading(false);
  }, [statusUpdated]);

  /**
   * Update Application Status By ReviewCode
   */
  const handleUpdateAppStatus = async () => {
    if (reviewStatusCode.new) {
      try {
        const params = { id: providerId, requestStatus: reviewStatusCode.code };
        await Axios.put(
          `${process.env.REACT_APP_API_URL_BASE}/provider/updateApplicationStatus`,
          params,
          {
            headers: {
              Authorization: "Bearer " + storeState[0].jwt, //the jwt is a variable which holds the token
            },
          }
        );
      } catch (error) {
        console.log(error);
        swal(
          "Error!",
          "Please try later or contact to the Administrator",
          "warning"
        );
      }
    }
  };

  //Change the provider Status (User and access to platform)
  const handleStatusChange = () => {
    setOpen(true); //block the screen until the request
    const provider_status = providerStatus === "enabled" ? "2" : "1";

    const params = {
      email: email,
      status_user_id: provider_status, // 1 for Enable ; 2 for Disable
      rol_id: "3", // 3 For Providers
    };
    Axios.put(
      `${process.env.REACT_APP_API_URL_BASE}/users/changeStatus`,
      params,
      {
        headers: {
          Authorization: "Bearer " + storeState[0].jwt, //the jwt is a variable which holds the token
        },
      }
    )
      .then((res) => {
        setOpen(false);
        swal("Success!", "Status updated", "success");
        setStatusUpdated(!statusUpdated);
      })
      .catch((err) => {
        console.log(err);
        setOpen(false);
        swal(
          "Error!",
          "Please try later or contact to the Administrator",
          "warning"
        );
      });
  };

  /**
   * Update Profile Info and Review Status if it has changed.
   */
  const handleClick = () => {
    if (
      phone &&
      firstName &&
      lastname &&
      dateOfBirth &&
      gender &&
      identification &&
      identificationType &&
      medicalLicense &&
      issuedBy &&
      summary &&
      selectedSpecialty.length > 0
    ) {
      setOpen(true);
      const specialtyArr = selectedSpecialty.map((specialty) => specialty.id);
      Axios.put(
        `${process.env.REACT_APP_API_URL_BASE}/provider/update`,
        {
          phone1: phone,
          firstName,
          lastname,
          dateOfBirth,
          gender,
          identificationType,
          identification,
          country,
          nationality,
          id: providerId,
          summary,
          specialty: specialtyArr,
          medical_license: medicalLicense,
          issued_by: issuedBy,
          primary_language: primaryLanguage,
          secondary_language: secondaryLanguage,
          provider_locations: selectedLocations,
          dental_ehr_enabled: dentalEhrEnabled,
          ai_enabled: aiEnabled,
        },
        {
          headers: { Authorization: "Bearer " + storeState[0].jwt }, //the jwt is a variable which holds the token
        }
      )
        .then((response) => {
          handleUpdateAppStatus();
          // assistant_enabled / assistant_input_token_limit are no longer
          // accepted by the generic provider/update endpoint (security fix:
          // any authenticated user could otherwise enable the assistant or
          // set an arbitrary credit limit for any provider). They are saved
          // separately via the admin-only assistant-access endpoint below.
          // This save runs in parallel with the generic save above and does
          // not block/replace it.
          Axios.patch(
            `${process.env.REACT_APP_API_URL_BASE}/provider/${providerId}/assistant-access`,
            {
              enabled: assistantEnabled,
              assistant_input_token_limit:
                assistantInputTokenLimit === ""
                  ? null
                  : Number(assistantInputTokenLimit),
            },
            {
              headers: { Authorization: "Bearer " + storeState[0].jwt },
            }
          ).catch((error) => {
            console.log(error);
            swal({
              tittle: "Warning!",
              text: "Profile updated, but the Virtual Assistant settings could not be saved.",
              icon: "warning",
            });
          });
          setOpen(false);
          swal({
            tittle: "Success!",
            text: "Profile updated successfully",
            icon: "success",
          });
        })
        .catch((error) => {
          setOpen(false);
          console.log(error);
        });
    } else {
      swal({
        tittle: "Warning!",
        text: "Required fields not filled out",
        icon: "warning",
      });
    }
  };

  // Get Locations Enabled
  const getLocations = async () => {
    try {
      const result = await Axios.get(
        `${process.env.REACT_APP_API_URL_BASE}/locations`,
        {
          headers: {
            Authorization: "Bearer " + storeState[0].jwt,
          },
        }
      );
      if (result) {
        setPlatformLocations(result.data);
      }
    } catch (error) {
      console.error("Something wrong", error);
    }
  };

  const PRACTICE_LOCATIONS_LIST = [
    {
      name: "VIRTUAL",
      id: 1,
      consultations_allowed: 99,
    },
    {
      name: "HCG Consultorio Clinico",
      id: 2,
      consultations_allowed: 0,
    },
  ];

  const handleAddLocation = () => {
    const location = platformLocations.find(
      (loc) => loc.id === parseInt(locationPreSelected)
    );
    // check if the location is not already in the list selectedLocations, if so throw an swal alert
    const locationExists = selectedLocations.find(
      (loc) => loc?.id === location?.id
    );
    if (locationExists) {
      swal({
        title: "Location already added",
        text: "Please select another location",
        icon: "warning",
      });
      return;
    }
    if (location) {
      // add the consultation_allowed to the location
      location.consultations_allowed = consultation_allowed;
      setSelectedLocations([...selectedLocations, location]);
      // clear the locationPreSelected
      setLocationPreSelected("");
      setConsultationAllowed(0);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <DashboardAdmin
      sectionTitle="Provider"
      description="Editing Provider"
      icon={providerIcon}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        aria-label="provider edit tabs"
        className={classes.tabs}
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="Profile Information" />
        <Tab label="Calendar Availability" />
      </Tabs>

      <TabPanel value={tabValue} index={0} className={classes.tabPanel}>
        <div className="shadow-lg p-3 mb-5 bg-white rounded">
          <div className="row d-flex justify-content-center">
            <div className="col-md-12 d-flex justify-content-center">
              <div className="row container-fluid  d-flex justify-content-center">
                <div className="col-md-4">
                  <article className="text-center">
                    <div className="img-cropper my-3">
                      {imgProfile && (
                        <img
                          src={imgProfile}
                          alt="profile avatar"
                          className="profile-avatar"
                        />
                      )}
                      {imgProfile == null && (
                        <img
                          src={ProfileImg}
                          alt="profile avatar"
                          className="profile-avatar"
                        />
                      )}
                      {imgLoading && (
                        <div className="mt-3">
                          <LoadingSpin type="spokes" color="#1d3557" />
                        </div>
                      )}
                    </div>
                    <p style={{ color: "#dc3545", marginBottom: "0" }}>
                      Specialist Rank
                    </p>
                    <StarsComponent editRate={false} />
                    <fieldset
                      style={{
                        border: "1px solid #e0e0e0",
                        borderRadius: "8px",
                        padding: "16px 20px",
                        marginBottom: "24px",
                      }}
                    >
                      <legend
                        style={{
                          fontSize: "0.85rem",
                          fontWeight: 600,
                          color: "#555",
                          padding: "0 8px",
                          width: "auto",
                        }}
                      >
                        Provider Settings
                      </legend>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "4px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Switch
                                checked={providerStatus === "enabled"}
                                onChange={handleStatusChange}
                                color="primary"
                                name="activateSwitch"
                                inputProps={{
                                  "aria-label": "provider status toggle",
                                }}
                              />
                            }
                            label="Account Enabled"
                            labelPlacement="start"
                            style={{
                              marginLeft: 0,
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Switch
                                checked={dentalEhrEnabled}
                                onChange={(e) =>
                                  setDentalEhrEnabled(e.target.checked)
                                }
                                color="primary"
                                name="dentalEhrSwitch"
                                inputProps={{
                                  "aria-label": "dental ehr toggle",
                                }}
                              />
                            }
                            label="Dental EHR"
                            labelPlacement="start"
                            style={{
                              marginLeft: 0,
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Switch
                                checked={aiEnabled}
                                onChange={(e) =>
                                  setAiEnabled(e.target.checked)
                                }
                                color="primary"
                                name="aiEnabledSwitch"
                                inputProps={{
                                  "aria-label": "ai enabled toggle",
                                }}
                              />
                            }
                            label="AI Features"
                            labelPlacement="start"
                            style={{
                              marginLeft: 0,
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Switch
                                checked={assistantEnabled}
                                onChange={(e) =>
                                  setAssistantEnabled(e.target.checked)
                                }
                                color="primary"
                                name="assistantEnabledSwitch"
                                inputProps={{
                                  "aria-label": "virtual assistant toggle",
                                }}
                              />
                            }
                            label="Virtual Assistant"
                            labelPlacement="start"
                            style={{
                              marginLeft: 0,
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <TextField
                            type="number"
                            label="Assistant Input Token Limit"
                            placeholder="Vacio = usa el limite global"
                            value={assistantInputTokenLimit}
                            onChange={(e) =>
                              setAssistantInputTokenLimit(e.target.value)
                            }
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          marginTop: "12px",
                          paddingTop: "12px",
                          borderTop: "1px solid #e0e0e0",
                        }}
                      >
                        <Button
                          variant="outlined"
                          color="default"
                          size="small"
                          startIcon={<CloudDownloadIcon />}
                          disabled={true}
                          fullWidth
                        >
                          Download Professional ID
                        </Button>
                      </div>
                    </fieldset>
                  </article>
                </div>
              </div>
            </div>
            <div className="col-md-9">
              <form className="row" id="patient-form">
                <div className="form-group col-md-6">
                  <TextField
                    margin="normal"
                    label="First Name"
                    variant="outlined"
                    id="firstName"
                    fullWidth
                    onChange={(e) => setfirstName(e.target.value)}
                    required
                    value={firstName || ""}
                  />
                </div>
                <div className="form-group col-md-6">
                  <TextField
                    required
                    fullWidth
                    margin="normal"
                    label="Last Name"
                    variant="outlined"
                    id="lastname"
                    onChange={(e) => setLastname(e.target.value)}
                    value={lastname || ""}
                  />
                </div>
                <div className="form-group col-md-12">
                  <TextField
                    required
                    margin="normal"
                    label="Your Email"
                    variant="outlined"
                    id="email"
                    value={email || ""}
                    autoComplete="email"
                    fullWidth
                    placeholder="name@example.com"
                    onChange={(e) => setEmail(e.target.value)}
                    disabled
                  />
                </div>
                <div className="form-group col-md-8">
                  <TextField
                    required
                    fullWidth
                    margin="normal"
                    label="Phone Number"
                    variant="outlined"
                    id="phoneNumber"
                    value={phone || ""}
                    placeholder="888823456"
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-4 ">
                  <TextField
                    id="country"
                    required
                    select
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    placeholder="Select"
                    label="Country"
                    value={country || "select"}
                    onChange={(e) => setCountry(e.target.value)}
                  >
                    {countries &&
                      countries.map((singleCountry) => (
                        <MenuItem
                          key={singleCountry.id}
                          value={singleCountry.code}
                        >
                          {singleCountry.name}
                        </MenuItem>
                      ))}
                  </TextField>
                </div>
                <div className="form-group col-md-3">
                  <TextField
                    id="identificationType"
                    required
                    select
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    placeholder="Select"
                    label="Identification Type"
                    onChange={(e) => setIdentificationType(e.target.value)}
                    value={identificationType || "select"}
                  >
                    <MenuItem value="DNI">DNI</MenuItem>
                    <MenuItem value="CED">Cedula de Identidad</MenuItem>
                    <MenuItem value="PASSPORT">Passport</MenuItem>
                    <MenuItem value="other">Other</MenuItem>
                  </TextField>
                </div>

                <div className="form-group col-md-9">
                  <TextField
                    required
                    fullWidth
                    margin="normal"
                    label="Identification/DNI"
                    variant="outlined"
                    id="identification"
                    onChange={(e) => setIdentification(e.target.value)}
                    value={identification || ""}
                  />
                </div>
                <div className="form-group col-md-4">
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    margin="normal"
                    id="dateOfBirth"
                    name="dateOfBirth"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    type="date"
                    label="Date Of Birth"
                    onChange={(e) => setDateOfBirth(e.target.value)}
                    value={dateOfBirth || ""}
                  />
                </div>
                <div className="form-group col-md-8">
                  <TextField
                    id="gender"
                    required
                    select
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    placeholder="Select"
                    label="Gender"
                    onChange={(e) => setGender(e.target.value)}
                    value={gender}
                  >
                    <MenuItem value={""}>None</MenuItem>
                    <MenuItem value={"MALE"}>Male</MenuItem>
                    <MenuItem value={"FEMALE"}>Female</MenuItem>
                    <MenuItem value={"OTHER"}>Other</MenuItem>
                  </TextField>
                </div>
                {/* Field for Primary and Secondary Lang */}
                <div className="form-group col-md-6">
                  <TextField
                    required
                    select
                    fullWidth
                    margin="normal"
                    label="Primary Language"
                    variant="outlined"
                    id="primary-language"
                    onChange={(e) => setPrimaryLanguage(e.target.value)}
                    value={primaryLanguage || ""}
                  >
                    <MenuItem value="EN">English</MenuItem>
                    <MenuItem value="ES">Spanish</MenuItem>
                  </TextField>
                </div>
                <div className="form-group col-md-6">
                  <TextField
                    required
                    select
                    fullWidth
                    margin="normal"
                    label="Secondary Language"
                    variant="outlined"
                    id="secondary-language"
                    onChange={(e) => setSecondaryLanguage(e.target.value)}
                    value={secondaryLanguage || ""}
                  >
                    <MenuItem value="EN">English</MenuItem>
                    <MenuItem value="ES">Spanish</MenuItem>
                  </TextField>
                </div>

                {/* License and Issued By */}

                <div className="form-group col-md-6">
                  <TextField
                    required
                    fullWidth
                    margin="normal"
                    label="Medical License"
                    variant="outlined"
                    id="medical-license"
                    onChange={(e) => setMedicalLicense(e.target.value)}
                    value={medicalLicense || ""}
                  />
                </div>

                <div className="form-group col-md-6">
                  <TextField
                    required
                    fullWidth
                    margin="normal"
                    label="Issued By"
                    variant="outlined"
                    id="issued-by"
                    onChange={(e) => setIssuedBy(e.target.value)}
                    value={issuedBy || ""}
                  />
                </div>

                {/* End License and Issued By */}
                <div className="form-group col-md-12">
                  <TextField
                    id="summary"
                    label="Professional Summary"
                    multiline
                    fullWidth
                    rows={5}
                    value={summary}
                    variant="outlined"
                    onChange={(e) => setSummary(e.target.value)}
                  />
                </div>
                {/* Specialties */}
                <div className="form-group col-md-12">
                  <FormControl className="col-md-12">
                    <Autocomplete
                      multiple
                      id="specialty"
                      options={specialty}
                      getOptionLabel={(option) => option?.speciality_name}
                      value={selectedSpecialty}
                      onChange={(e, val, reason, details) => {
                        handleChangeSpecialty(val);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Specialty"
                          placeholder="Specialties"
                        />
                      )}
                    />
                  </FormControl>
                </div>
                {/* End Specialty */}

                {/* Provider Locations */}
                <div className="form-group col-md-6">
                  <TextField
                    required
                    select
                    fullWidth
                    margin="normal"
                    label="Locations"
                    variant="outlined"
                    id="locations"
                    onChange={(e) => {
                      setLocationPreSelected(e.target.value);
                    }}
                    // value={primaryLanguage || ""}
                  >
                    {platformLocations.length > 0 &&
                      platformLocations.map((location) => (
                        <MenuItem key={location.id} value={location.id}>
                          {location.name}
                        </MenuItem>
                      ))}
                  </TextField>
                </div>
                <div className="form-group col-md-4">
                  <TextField
                    required
                    type="number"
                    fullWidth
                    margin="normal"
                    label="Consultation Allowed"
                    variant="outlined"
                    id="consultations-allowed"
                    onChange={(e) => setConsultationAllowed(e.target.value)}
                    value={consultation_allowed || ""}
                  />
                </div>
                <div className="form-group col-md-2 d-flex align-items-center">
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleAddLocation}
                  >
                    Add
                  </Button>
                </div>
                {/* Chips with locations selected */}
                <div className="form-group col-md-12">
                  <FormControl className="col-md-12">
                    <Autocomplete
                      multiple
                      id="locations"
                      options={platformLocations}
                      getOptionLabel={(option) =>
                        `${option?.name} - ${option?.consultations_allowed}`
                      }
                      value={selectedLocations}
                      onChange={(e, val, reason, details) => {
                        swal({
                          title: "Warning!",
                          text: "Adding new locations from here will set the Consultation Allowed to 0",
                          icon: "warning",
                        });
                        setSelectedLocations(val);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Locations Assigned"
                          placeholder="Locations"
                        />
                      )}
                    />
                  </FormControl>
                </div>

                {/* Provider Application Status */}
                <div className="form-group col-md-6">
                  <TextField
                    id="applicaton-status"
                    required
                    select
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    placeholder="Select..."
                    label="Application Status"
                    onChange={(e) =>
                      setReviewStatusCode({
                        new: true,
                        code: e.target.value,
                      })
                    }
                    value={reviewStatusCode.code}
                  >
                    <MenuItem value="IREV">UNDER REVIEW</MenuItem>
                    <MenuItem value="APR">APPROVED</MenuItem>
                    <MenuItem value="REJ">REJECTED</MenuItem>
                    <MenuItem value="AWA">AWAITING</MenuItem>
                  </TextField>
                </div>
                {/* End Application Status */}
              </form>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 d-flex justify-content-center ">
              <div className="p-3">
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<CheckCircleOutlineIcon />}
                  onClick={handleClick}
                >
                  Save
                </Button>
              </div>

              <div className="p-3">
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<CancelIcon />}
                  onClick={(e) => {
                    history.goBack();
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div>
          {loading ? (
            <LoadingSpin type="spokes" color="#1d3557" />
          ) : (
            <PatientsForProvider data={patients} parentComponent="admin" />
          )}
        </div>
      </TabPanel>

      <TabPanel value={tabValue} index={1} className={classes.tabPanel}>
        <AdminProviderPlanner
          providerId={providerId}
          jwt={storeState[0].jwt}
          providerLocations={selectedLocations}
        />
      </TabPanel>
    </DashboardAdmin>
  );
}

export default ProviderEditFromAdmin;
